// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/surface-contamination.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/surface-contamination/surface-contamination.js';

mount([g0]);
